
// export const myGetter = ( state ) => {
//  return state
// }

export const inputdetailsList = state => state.inputdetails
export const inputdetailsSelectable = state => state.inputdetailsSelectable
export const inputdetailsPaginatedData = state => state.inputdetailsPaginatedData
export const inputdetail = state => state.inputdetail
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData
export const selectedListData = state => state.selectedListData
export const isSelecting = state => state.isSelecting